module.exports = __webpack_public_path__ + "images/banners/company_recruitment/banner_mini_0d877bf4045d70bc19382a2ab6f52fba.jpg";